import React, { useState } from "react";
import { Select } from "antd";

const { Option } = Select;
export const Filter = ({ selectedItem, fetchDistinct, onChange, placeholder, token, filters, width }) => {
  const [items, setItems] = useState([]);

  return (
    <Select
      allowClear={true}
      showSearch
      placeholder={placeholder}
      style={{ width: width || 200, margin: 5 }}
      value={selectedItem}
      onFocus={async () => {
        const response = await fetchDistinct(filters, token);
        setItems(response);
      }}
      onChange={onChange}
    >
      {items.map(client => (
        <Option key={client} value={client}>
          {client}
        </Option>
      ))}
    </Select>
  );
};



// WEBPACK FOOTER //
// src/modules/presence/expenseReports/Accounting/components/Filter.component.js